var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "var(--button-priority)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_9351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21H9V10H15.61L16.61 9H9C8.73478 9 8.48043 9.10536 8.29289 9.29289C8.10536 9.48043 8 9.73478 8 10V21C8 21.2652 8.10536 21.5196 8.29289 21.7071C8.48043 21.8946 8.73478 22 9 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V13.5L20 14.5V21Z",
    fill: "var(--button-priority)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7647 8.91961L21.0797 7.23461C21.005 7.15962 20.9161 7.10013 20.8183 7.05953C20.7205 7.01894 20.6156 6.99805 20.5097 6.99805C20.4038 6.99805 20.299 7.01894 20.2012 7.05953C20.1034 7.10013 20.0145 7.15962 19.9397 7.23461L13.0847 14.1296L12.5297 16.5346C12.5061 16.6512 12.5086 16.7716 12.537 16.8871C12.5655 17.0026 12.6191 17.1103 12.6942 17.2026C12.7693 17.2949 12.8638 17.3694 12.9711 17.4207C13.0784 17.4721 13.1958 17.499 13.3147 17.4996C13.3762 17.5063 13.4383 17.5063 13.4997 17.4996L15.9247 16.9646L22.7647 10.0596C22.8397 9.98483 22.8992 9.89599 22.9398 9.79818C22.9804 9.70036 23.0013 9.59551 23.0013 9.48961C23.0013 9.38371 22.9804 9.27885 22.9398 9.18104C22.8992 9.08323 22.8397 8.99439 22.7647 8.91961ZM15.4047 16.0396L13.5747 16.4446L13.9997 14.6296L19.1597 9.43461L20.5697 10.8446L15.4047 16.0396ZM21.1347 10.2796L19.7247 8.86961L20.4997 8.07961L21.9197 9.49961L21.1347 10.2796Z",
    fill: "var(--button-priority)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_9351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "var(--background)",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/iconEdit.f8ceea8b0d952310d6021a742d78ddca.svg";
export { ForwardRef as ReactComponent };